import { styled } from '@mui/material/styles';
import { Divider } from '@mui/material';
import CustomScrollBar from 'common/components/customScroll';
import { CONSTANTS } from 'features/floatingTicketPanel/utils/constants';

export const StyledNavbar = styled('div')`
  background-color: ${(props) => props.theme.palette.generic.primary};
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  min-height: 100%;
  display: flex;
  flex-direction: column;

  &.collapsed {
    width: ${CONSTANTS.NAV_BAR_COLLAPSED_WIDTH}px;
    max-height: 100%;
    .vertical-scrollbar {


      right: -6px !important;
    }
  }

  &.expanded {
    width: ${CONSTANTS.NAV_BAR_EXPANDED_WIDTH}px;
    max-height: 100%;
    .vertical-scrollbar {
      right: 0 !important;
      &::-moz-scrollbar-track {
          width: 12px;
          scrollbar-width: thin;
      }
      div {
        background-color: #e6e6e6 !important;
      }
    }
  }
`;

export const StyledScrollBar = styled(CustomScrollBar)`
  height: calc(100% - 75px) !important;
  margin-bottom: 20px !important;
`;

export const StyledDivider = styled(Divider)`
  border-color: ${(props) => props.theme.palette.background.pages_background};
  padding-top: 0;
  margin-bottom: 24px;
`;
